import { VueContentPopover } from "@/app/popover/VueContentPopover";
import type { IAddCancellationCmd } from "@/data/commands/order/AddCancellationCmd";
import CancellationReasonPopoverForm from "@/components/order/CancellationReasonPopoverForm.vue";
import { translations } from "@/shared/localization/translations";

export class CancellationReasonPopover extends VueContentPopover {
    constructor(
        locationId: string,
        orderId: string,
        cancellableAmount: number,
        data: IAddCancellationCmd,
        onSaveStart?: () => void,
        onSaveError?: (errorCode: string, errorMessage: string) => void,
        onSaveEnd?: () => void,
    ) {
        super({ title: `${translations.cancellation.cancellation} - ${translations.cancellationReason.reason}`,  popoverClass: "cancellation-reason-popover", fullscreen: false,    flexHeight: true,
            condensed: true});

        const props = {
            locationId: locationId,
            orderId: orderId,
            cancellableAmount: cancellableAmount,
            data: data,
            onSaveStart: onSaveStart,
            onSaveError: onSaveError,
            onSaveEnd: onSaveEnd,
        };
        this.initComponent(CancellationReasonPopoverForm, props);
    }
}